module.exports = __webpack_public_path__ + "img/4_78.b5ca1f4c.png";